import React from 'react';

import { BasePopupActionPayload, BasePopupProps } from 'contexts/PopupContext';
import { MirrorService } from 'services/MirrorService';

import { useLimitTimeOfferPopupBL } from './hooks/useLimitTimeOfferPopupBL';
import { LimitTimeOfferPopupDefaultTheme } from './themes/LimitTimeOfferPopupDefaultTheme';
import { LimitTimeOfferPopupMeplusyouTheme } from './themes/LimitTimeOfferPopupMeplusyouTheme';

type LimitTimeOfferPopupActionsPayload =
  | BasePopupActionPayload<'submit'>
  | BasePopupActionPayload<'close'>;

type Props = BasePopupProps<
  null,
  (action: LimitTimeOfferPopupActionsPayload) => void
>;

export const LimitTimeOfferPopup: React.FC<Props> = ({ onAction }) => {
  const handleSubmit = () => {
    onAction({ type: 'submit' });
  };

  const handleClose = () => {
    onAction({ type: 'close' });
  };

  useLimitTimeOfferPopupBL();

  return MirrorService.isMePlusYouOrLocalsjoy ? (
    <LimitTimeOfferPopupMeplusyouTheme
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  ) : (
    <LimitTimeOfferPopupDefaultTheme
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  );
};
